module.exports = __webpack_public_path__ + "static/media/circle_outline_with_exclamation.ffe13ae3.svg";